/**
 * Created by Languagenut on 25/01/2019.
 */



import React  from 'react';
import './payment.css';
import FieldGroup from "../FieldGroup.js";
import {Button , Row , Col } from "react-bootstrap";
import LicenceService from '../../services/licence-service.js';

export default class Invoice extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
        }
    }

    onClick(){
        LicenceService.xeroPayment(this.props.packageData , this.props.userData).then(function(resolve){

        });
    }


    render(){
        return <div>
                <br/>
                <form >
                    <Row>
                        <Col md={12}>
                            <FieldGroup
                                id="phone_number"
                                name="number"
                                type="text"
                                label="Establishment Phone"
                                placeholder="Enter text" />
                        </Col>
                        <Col md={12}>
                            <FieldGroup
                                id="purchese_order_number"
                                name="number"
                                type="text"
                                label="Purchase order number (optional)"
                                placeholder="Enter text" />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}><Button onClick={this.onClick.bind(this)} block>Send Invoice & create account</Button></Col>
                    </Row>
                </form>
            <br/>
            </div>
    }
}